import { Form, Row, Col, FormGroup, Input, Label, Button, Spinner } from 'reactstrap';
import styles from './AddFeedback.module.scss';
import { useOnChangeHandler } from '../../utils/hooks/useOnChangeHandler';
import useApiPrivate from '../../utils/hooks/useApiPrivate';
import { useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';

const FEEDBACK_URL = 'api/v1/feedback';

export default function AddFeedback() {
    const apiPrivate = useApiPrivate();
    const [searchParams,setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const toast = useRef(null);


    const [isLoading, setIsLoading] = useState(false);
    const [orderId, setOrderId] = useState(searchParams.get('order') || '');
    const [ feedbackTo, setFeedbackTo] = useState(searchParams.get('username') || '');

    const [feedback, setFeedback, onChangeHandlerFeedbak] = useOnChangeHandler('');
    const [feedbackDescription, setFeedbackDescription, onChangeHandlerFeedbakDescription] = useOnChangeHandler('');

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const handleAddFeedback = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        try {
            const responsive = await apiPrivate.post(FEEDBACK_URL,{
                order_id: orderId && orderId,
                type: feedback && feedback,
                description: feedbackDescription && feedbackDescription
            });
            setIsLoading(false);
            showSuccess('Your feedback has been successfully registered')
            setTimeout(() => {
                navigate('/dashboard/my-orders');
            },3000);
        }
        catch (error) {
            setIsLoading(false);
            showError(error?.response?.data?.message)
        }
    }

    const handleBackButtom = () => {
        navigate(-1);
    }

  return (
    <>
        <Toast ref={toast} position="top-center" />  
        <div
            className={`lgtBackground p-4 bg-white ${styles.addFeedback} h-100`}
        > 
        <Row>
            <Col md={12}>
                {
                    <Button 
                        className={`text-decoration-none mb-3`}
                        onClick={() => handleBackButtom()}
                    >
                        <i className="bi bi-arrow-left"></i>
                    </Button>
                }
            </Col>
        </Row>
            <Form>
                <Row>
                    <Col sm={12} md={6}>
                        <FormGroup floating>
                            <Input
                                id="username"
                                name="username"
                                type="text"
                                value={feedbackTo}
                                disabled
                                />
                            <Label for="username">
                                Username
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={6}>
                    <div className='mb-3'>
                        <Label className='d-block mb-2 fw-semibold'>
                            Feedback:
                            <span className='text-danger'>*</span>
                        </Label>
                        <Input
                            type="radio"
                            name="type"
                            value="POSITIVE"
                            className={`invisible ${styles.removeRadio}`}
                            id="satisfied"
                            checked={feedback === "POSITIVE"}
                            onChange={onChangeHandlerFeedbak}
                        />
                        <Label 
                            htmlFor="satisfied"
                            className={`outlinBtn ms-2 p-1 ${feedback == "POSITIVE" ? 'active' : ''}`}
                            >
                            <i className={`bi bi-emoji-smile me-1 ${styles.happy}`}></i>
                            satisfied
                            </Label>

                        <Input
                            type="radio"
                            name="type"
                            value="NEUTRAL"
                            className={`invisible ${styles.removeRadio}`}
                            id="acceptable"
                            checked={feedback === "NEUTRAL"}
                            onChange={onChangeHandlerFeedbak}
                        />
                        <Label 
                            htmlFor="acceptable"
                            className={`outlinBtn ms-2 p-1 ${feedback == "NEUTRAL" ? 'active' : ''}`}
                            >
                            <i className={`bi bi-emoji-neutral me-1 ${styles.acceptable}`}></i>
                            acceptable
                            </Label>
                        <Input
                            type="radio"
                            name="type"
                            value="NEGATIVE"
                            className={`invisible ${styles.removeRadio}`}
                            id="negative"
                            checked={feedback === "NEGATIVE"}
                            onChange={onChangeHandlerFeedbak}
                        />
                        <Label 
                            htmlFor="negative"
                            className={`outlinBtn ms-2 p-1 ${feedback == "NEGATIVE" ? 'active' : ''}`}
                            >
                            <i className={`bi bi-emoji-frown me-1 ${styles.unhappy}`}></i>
                            negative
                            </Label>
                    </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={6}>
                        <FormGroup floating>
                            <Input
                                id="description"
                                className={`${styles.description}`}
                                name="description"
                                type="textarea"
                                value={feedbackDescription}
                                onChange={onChangeHandlerFeedbakDescription}
                                />
                            <Label for="description">
                                Description
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={6}>
                        <Button
                            onClick={(e) => handleAddFeedback(e)}
                            type='submit'
                            disabled={!feedback || isLoading && true}
                        >
                            {
                                isLoading 
                                ? (
                                    <>
                                    <Spinner size="sm">
                                        Loading...
                                    </Spinner>
                                    <span>
                                        {' '}Loading
                                    </span>
                                    </>
                                )
                                : 'Add Feedback'
                            }
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    </>
  )
}
